import { createSelector } from '@ngrx/store';

import {
  selectVistaUsuario,
  VistaUsuarioState
} from '../../vista-usuario/vista-usuario.state';
import { entityEstadosRolAdapter, EntityEstadosRolState } from './entity-estados-rol.state';

const { selectEntities, selectAll } = entityEstadosRolAdapter.getSelectors();

export const getError = (state: EntityEstadosRolState): any => state.error;

export const getIsLoading = (state: EntityEstadosRolState): boolean =>
  state.isLoading;

export const selectEstadosRolState = createSelector(
  selectVistaUsuario,
  (state: VistaUsuarioState) => state.estadosRol
);

export const selectAllEstadosRol = createSelector(selectEstadosRolState, selectAll);
export const selectEntitiesEstadosRol = createSelector(
  selectEstadosRolState,
  selectEntities
);

// MemoizedSelector<object,any>
export const selectEstadosRolError = createSelector(
  selectEstadosRolState,
  getError
);

// MemoizedSelector<object,any>
export const selectEstadosRolIsLoading = createSelector(
  selectEstadosRolState,
  getIsLoading
);
